import PendoEditableContent from '../../components/editable-content/pendo-editable-content.vue.js';
import PendoLoading from '../../directives/loading/pendo-loading.js';
import { hasSlot } from '../../utils/utils.js';

var script = {
  name: 'PendoPageHeader',
  components: {
    PendoEditableContent
  },
  directives: {
    PendoLoading
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: undefined
    },
    editable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maxWidth: '100%',
      isWrapped: false,
      actionObserver: null,
      editableContentObserver: null
    };
  },
  computed: {
    hasActions() {
      return hasSlot(this, 'actions');
    },
    hasTop() {
      return hasSlot(this, 'top');
    },
    hasBottom() {
      return hasSlot(this, 'bottom');
    },
    hasTags() {
      return hasSlot(this, 'tags');
    }
  },
  mounted() {
    this.setMaxWidth();
    if (this.hasActions) {
      this.initActionObserver();
    }
    if (this.editable) {
      this.initEditableContentObserver();
    }
  },
  beforeDestroy() {
    if (this.actionObserver) {
      this.actionObserver.disconnect();
      this.actionObserver = null;
    }
    if (this.editableContentObserver) {
      this.editableContentObserver.disconnect();
      this.editableContentObserver = null;
    }
  },
  methods: {
    setMaxWidth() {
      let maxWidth = this.$refs.wrapper.clientWidth - 36;
      if (this.hasTags && this.$refs.tags) {
        maxWidth -= this.$refs.tags.clientWidth;
      }
      this.maxWidth = maxWidth;
    },
    initActionObserver() {
      this.actionObserver = new ResizeObserver(entries => {
        const actionsSlot = entries[0].target;
        this.isWrapped = actionsSlot.offsetTop > this.$refs.content.offsetTop;
      });
      this.actionObserver.observe(this.$refs.actions);
    },
    initEditableContentObserver() {
      this.editableContentObserver = new ResizeObserver(this.setMaxWidth.bind(this));
      this.editableContentObserver.observe(this.$refs.wrapper);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-page-header.vue2.js.map
